(function() {

window.w = window;
w.d = document;
w.ui = {};
w.ui.langCode = 'uk';
w.ui.lang = {
"bank_account_description":"Після оформлення замовлення менеджер надсилає рахунок-фактуру на оплату",
"bank_account_title":"Оплата на розрахунковий рахунок",
"button_1click_short":"В 1 клік",
"button_checkout":"Оформлення замовлення",
"button_checkout1":"Оформити в 1 клік",
"button_continue_select":"Продовжити вибір",
"button_delete":"Видалити",
"button_delete_all":"Очистити",
"button_shopping":"Продовжити покупки",
"chat_message":"Напишіть нам!",
"cod_description":"",
"cod_title":"Оплата при отриманні",
"info_24h_shipping_modal_description":"<p>Ви можете зробити замовлення на сайті у режимі 24/7 і також за телефоном <a class=\"email binct-phone-number-1\" href=\"tel:0 800 337 137\" aria-label=\"telephone\" rel=\"noopener noreferrer nofollow\">0 800 337 137</a> у будні з 09:00 до 18:00.</p>\n<p>Ми надсилаємо замовлення протягом 24 годин із моменту підтвердження. Зауважте, що непідтверджені замовлення не надсилаються. Підтвердженням вважається погодження замовлення менеджером в телефонному режимі або електронною поштою. Автоматично підтверджуються замовлення, в яких вказані всі необхідні для відправки данні.</p>\n<p>Шановний покупцю! Будь ласка, зверніть увагу, що надсилання товарів здійснюється в будні о 12:00. Тобто, якщо ви хочете, щоб замовлення поїхало до вас сьогодні, воно повинне бути сформоване, підтверджене й оплачене (у разі вибору передоплати на розрахунковий рахунок) до цього часу.</p>",
"info_24h_shipping_modal_title":"Відвантаження протягом 24 годин",
"info_guarantee_and_service_modal_description":"<p><b>Умови гарантійного обслуговування:</b></p>\n<ul>\n <li>Термін дії гарантії на товар - від 24 до 60 місяців. Гарантійний термін починається з моменту доставки і отримання Покупцем товару в місце призначення відповідно до замовлення.</li>\n <li>Для гарантійного обслуговування необхідно підтвердження покупки в нашому інтернет-магазині (всі відправлені замовлення фіксуються в нашій базі з усією супутньою інформацією), і наявність гарантійного чека або товарно-транспортної накладної, виданої компанією-перевізником при отриманні замовлення.</li>\n <li>Гарантійне обслуговування включає в себе проведення ремонтних робіт і заміну дефектних частин товару. Термін гарантії в такому випадку не продовжується на час перебування виробу в ремонті.</li>\n <li>Претензії по зовнішньому вигляду товару, механічним пошкодженням, некомплекту, а також невідповідності замовлення приймаються безпосередньо при отриманні товару. Надалі такі претензії не розглядаються, всі роботи здійснюються тільки за рахунок Покупця.</li>\n <li>Гарантія діє тільки на території України.</li>\n <li>Гарантія не поширюється на витратні матеріали (кабелі, гумові елементи, ремені, м'які ручки, педалі, підшипники), в разі якщо пройшло більше 14 днів з моменту покупки.</li>\n <li>Рекомендуємо відключати блоки живлення електро тренажерів від електромережі під час відсутності електропостачання, або використовувати стабілізатор напруги. Виробник не несе відповідальності за наслідки перепадів напруги, які можуть призвести до пошкодження блоків живлення та систем тренажера.\nУ випадку виявлення таких пошкоджень сервісне обслуговування надається на платній основі.</li>\n</ul>\n<p><b>Гарантійне обслуговування не здійснюється в разі:</b></p>\n<ul>\n <li>Закінчення гарантійного терміну.</li>\n <li>Відсутності інформації про покупку в базі даних нашого магазину або документів, що підтверджують покупку (гарантійний талон).</li>\n <li>Виникнення механічних та інших пошкоджень (сколи, подряпини, тріщини в результаті удару, падіння або надмірного навантаження).</li>\n <li>Появи слідів корозії на металевих деталях в результаті пошкодження лако-фарбового покриття.</li>\n <li>Виникнення пошкоджень або втрати виробу, викликаних діями непереборної сили (стихійні лиха, пожежі, повені і т.п.).</li>\n <li>Появи пошкоджень в результаті недбалого ставлення (недотримання температурного режиму та режиму вологості, перевищення максимально допустимого навантаження, використання неякісних засобів по догляду та чищенню).</li>\n <li>Використання товару в комерційних цілях та/або не в домашніх умовах.</li>\n <li>Природного зносу, який можна очікувати в разі активного використання продукту (вигоряння тканин, забруднення, потертості).</li>\n</ul>\n<p><b>Умови здачі товару в ремонт:</b></p>\n<p>При пересиланні товару на гарантійний ремонт або обслуговування, товар повинен направлятися в розібраному вигляді, в оригінальній упаковці, зі збереженням усіх елементів, інструкції, надійно упакованим, щоб убезпечити товар від пошкодження. Без обрешітки або палетування.</p>\n<p>Вартість доставки на гарантійне обслуговування оплачує клієнт, і після виявлення причини поломки, і визнання випадку гарантійним - ми компенсуємо Покупцеві вартість пересилки до нас. У разі визнання випадку не гарантійним - всі витрати, пов'язані з транспортуванням і ремонтом оплачує покупець.</p>\n<p><b>Обмін і повернення товару:</b></p>\n<p>Ви маєте право обміняти або повернути куплений у нас товар протягом 14 днів при дотриманні наступних умов:</p>\n<ul>\n <li>товар не використовувався, не був у збірці (монтажі)</li>\n <li>збережений товарний вигляд</li>\n <li>збережена оригінальна упаковка товару і всі її компоненти</li>\n <li>збережена комплектація товару</li>\n</ul>\n<p><b>Увага!</b> Доставка в разі обміну товару належної якості або його повернення здійснюється покупцем за свій рахунок.</p>",
"info_guarantee_and_service_modal_title":"Гарантія та сервіс",
"text_action_to":"Акція до",
"text_agree_cart":"Підтверджуючи замовлення, ви погоджуєтесь з правилами <a href=\"/oplata-i-kredytuvannya\" target=\"_blank\">купівлі</a>, <a href=\"/dostavka-ta-povernennya-tovaru\" target=\"_blank\">доставки та повернення</a>.",
"text_app_btn":"Встановити PWA",
"text_apply":"Застосувати",
"text_area":"обл.",
"text_button":"Оформити",
"text_cart":"Кошик",
"text_cart_empty":"Ваш кошик порожній",
"text_cashback_accept":"Прийняти умови",
"text_cashback_brand":"Besport Bonus",
"text_cashback_col_orders":"Сума замовлення",
"text_cashback_col_photo":"Фото / Відгук",
"text_cashback_col_video":"Відеоогляд",
"text_cashback_intro":"Поділіться враженнями в Instagram або Tik Tok та отримайте до 1200 грн на картку.",
"text_cashback_note_1":"Якщо у замовленні більше 1 товару — кешбек рахується на загальну суму за умови оглядів на <span class=\"underline decoration-yellow-400 decoration-2\">кожен</span> товар.",
"text_cashback_note_2":"Кешбек не сумується та не переноситься на майбутні покупки.",
"text_cashback_special_label":"Спецпропозиція",
"text_cashback_special_title":"Кешбек подвоюється!",
"text_cashback_step_1":"Підпишіться на наш профіль в Instagram або Tik Tok",
"text_cashback_step_2":"Зробіть фото або відеоогляд з придбаним товаром",
"text_cashback_step_3":"Тегніть нашу сторінку у дописі або сторіс",
"text_cashback_steps":"Що потрібно зробити",
"text_cashback_tier_1":"до 5 000 грн",
"text_cashback_tier_2":"5 001 – 10 000 грн",
"text_cashback_tier_3":"10 001 – 15 000 грн",
"text_cashback_tier_4":"15 001 – 20 000 грн",
"text_cashback_tier_5":"від 20 001 грн",
"text_cashback_title":"Отримайте кешбек",
"text_cashback_title_accent":"за ваш відгук!",
"text_cashback_video_eq":"Відеоогляд =",
"text_cashback_video_x2":"x2 БОНУС",
"text_chat":"Чат",
"text_chat_greetings":"Привіт. Маєте запитання?<br>Ми готові вам допомогти",
"text_chat_new_messages":"нові повідомлення",
"text_chat_not_working_time":"Вітаємо, нажаль зараз неробочий час. Менеджер не має можливості прийняти участь в розмові. Ми завжди раді допомогти з 9:00-18:00 з Пн-Пт",
"text_chat_server_disconnected":"Вибачте на даний момент наш сервер чату не працює. Спробуйте через декілька хвилин",
"text_chat_typing":"пише",
"text_close":"Закрити",
"text_comment":"Коментар",
"text_currency_unit":"₴",
"text_day":"день",
"text_day2":"дні",
"text_day5":"днів",
"text_description":"Для уточнення вашого кредитного ліміту відправте смс<br>з текстом \"CHAST\" на номер {sms} або подзвоніть на {tel}<br>* Кредит оформлюється на вище вказану безготівкову вартість товару",
"text_done":"Готово",
"text_email":"EMail",
"text_enter_message":"Написати повідомлення",
"text_fail_text":"Якщо у вас виникли питання, будь ласка зв'яжіться з нами. Можете спробувати інші типи оплати",
"text_fail_title":"Оплата вашого замовлення #order_id не успішна",
"text_filter":"Фільтрувати",
"text_filter_clear":"Очистити фільтр",
"text_filters":"Фільтри",
"text_found":"Знайдено",
"text_from":"від",
"text_home":"Головна",
"text_hotline":"Гаряча лінія",
"text_in_cart":"У кошику",
"text_input_required":"Не заповнене",
"text_instock":"В наявності",
"text_label_quantity_few":"Закінчується",
"text_manager":"Менеджер Outtec",
"text_manager_message_cart":"Передзвонимо за 5 хвилин для уточнення адреси доставки",
"text_month_short":"міс",
"text_months":"Місяців",
"text_name":"Ім'я",
"text_no_products_in_cart":"Додайте товари у кошик",
"text_not_in_stock_btn":"Очікуємо поставки",
"text_notify_button":"Повідомте",
"text_notify_me":"Повідомте, коли з'явиться",
"text_offer_agree":"Натискаючи на кнопку, ви погоджуєтесь з правилами",
"text_offers_text":"Ми підібрали для вас схожі товари",
"text_offers_title":"Вибачте, даний товар відсутній на складі",
"text_or":"або",
"text_payments":"Платежів",
"text_phone_error":"Телефон повинен мати 10 цифр і починатись з 0",
"text_phys":"грн / міс",
"text_price_discount":"Заощаджуєте",
"text_price_total":"До оплати",
"text_products":"товарів",
"text_public_offer":"публічної оферти",
"text_quantity_few":"Закінчується",
"text_rating":"Рейтинг",
"text_reference":"Довідка",
"text_removed_product":"Видалено не існуючий товар ",
"text_review_add":"Додати відгук",
"text_search":"Пошук",
"text_shipping_modal_text":"<p>Текст-заглушка про терміни відвантаження та способи доставки. Замініть його в адмінці.</p>",
"text_shipping_modal_title":"Відвантаження протягом 24 годин",
"text_sort":"Сортувати",
"text_success_cashback":"Ми вдячні за вибір наших товарів та хочемо зробити вам приємність у вигляді <b>кешбеку</b> за це замовлення",
"text_success_details":"Детальніше тут",
"text_success_text":"Якщо у вас виникли питання, будь ласка зв'яжіться з нами. Дякуємо за покупки в нашому інтернет-магазині",
"text_success_text1":"Ваше замовлення <b>#{order_id}</b> успішно оформлено.<br>Менеджер зателефонує для підтвердження найближчим часом.",
"text_success_title1":"Дякуємо за замовлення",
"text_success_title2":"Чудовий вибір",
"text_telephone":"Телефон",
"text_telephone_notice":"Введіть номер для швидкого оформлення",
"text_title_ii":"«Миттєва розстрочка»",
"text_title_pp":"«Оплата частинами»",
"text_to":"до",
"text_total":"Вартість",
"text_total_payment":"Сума платежу",
"text_uah_per_month":"грн/міс",
"text_val_format":"Невірний формат",
"text_val_max":"Максимум %s символів",
"text_val_min":"Мінімум %s символів",
"text_val_required":"Обов'язкове поле",
"text_val_value":"Невірне значення",
"text_warranty":"гарантії",
"text_warranty_modal_text":"<p>Текст-заглушка про умови гарантії та сервісного обслуговування. Замініть його в адмінці.</p>",
"text_warranty_modal_title":"Гарантія та сервіс",
"text_weight_unit":"кг",
"text_wish_products":"Вподобані товари",
"text_write":"Надіслати відгук",
"text_year1":"рік",
"text_year2":"роки",
"text_year3":"роки",
"text_year4":"роки",
"text_year5":"років",
"wayforpay_applepay_description":"Платіж відбувається миттєво, зручний спосіб оплати для власників iPhone або Apple Watch",
"wayforpay_applepay_title":"Apple Pay",
"wayforpay_card_description":"",
"wayforpay_card_title":"Оплата картою",
"wayforpay_googlepay_description":"Платіж відбувається миттєво, зручний спосіб оплати для власників з пристроями з Android",
"wayforpay_googlepay_title":"Google Pay",
"wayforpay_paypartsabank_description":"Оплата частинами для власників карток А-Банку. Комісія 0%. Можлива кількість частин: 2, 3, 4, 5.",
"wayforpay_paypartsabank_title":"Оплата частинами А-Банк",
"wayforpay_paypartsmono_description":"Оплата частинами для власників карток Монобанку. Комісія 0%. Можлива кількість частин: 3, 4, 5.",
"wayforpay_paypartsmono_title":"Оплата частинами Монобанк",
"wayforpay_paypartsotp_description":"Оплата частинами для власників карток OTP Банку. Комісія 0%. Можлива кількість частин: 3, 4.\r\nМінімальна сума для покупки частинами 300 грн.",
"wayforpay_paypartsotp_title":"Оплата частинами OTP",
"wayforpay_paypartsprivat_description":"Оплата частинами для власників карток Приватбанку. Комісія 0%. Можлива кількість частин: 2, 3, 4.",
"wayforpay_paypartsprivat_title":"Оплата частинами ПриватБанк",
"wayforpay_paypartspumb_description":"Оплата частинами для власників карток ПУМБ. Комісія 0%. Можлива кількість частин: 3, 4, 5.",
"wayforpay_paypartspumb_title":"Оплата частинами ПУМБ",
"wayforpay_privat24_description":"Можливість здійснити платіж через додаток Приват24",
"wayforpay_privat24_title":"Оплата в Приват24"
};

})();